import { render } from "./Header_enviro.vue?vue&type=template&id=cbe3aa72"
import script from "./Header_enviro.vue?vue&type=script&lang=js"
export * from "./Header_enviro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__